import { useEffect } from 'react';
import emitter from '../util/emitter';
import useEventCallback from './useEventCallback';

function useEvent(type, fn) {
  const callback = useEventCallback(fn);
  useEffect(() => {
    emitter.on(type, callback);
    return () => emitter.off(type, callback);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type]);
}

export default useEvent;
